import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { platformSelect } from '@bubble-ui/util-platform';
import { isDarkMode } from '@bubble-ui/particle-design-versions';
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    designVersion,
    inverse,
    gray
  } = _ref;
  var color = gray ?
  // Hard coded values, because the logo colors should not depend on a design version
  isDarkMode(designVersion) ? '#787573' : '#969391' : inverse ? isDarkMode(designVersion) ? '#17120F' : '#FFFFFF' : isDarkMode(designVersion) ? '#FFFFFF' : '#17120F';
  return {
    rootStyle: {
      fill: color
    },
    surfaceSize: {
      width: 81,
      height: 20
    },
    suffixStyle: _objectSpread(_objectSpread({
      color
    }, designContext.get('text-style/text/labels/tall/regular').styles()), {}, {
      fontSize: 24,
      lineHeight: 20,
      height: 20,
      paddingLeft: 5
    }, platformSelect({
      native: {
        paddingTop: 5
      },
      default: {
        paddingTop: 1,
        marginBottom: -1
      }
    })),
    wrapperStyle: {
      flexDirection: 'row',
      alignItems: 'center'
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map